(function() {
  var observers = [];

  function initStickyCta(stickyEl) {
    if (stickyEl.dataset.navInited === 'true') return;
    stickyEl.dataset.navInited = 'true';

    var bar = stickyEl.querySelector('[data-stuck]');
    if (!bar) return;

    var section = stickyEl.closest('[data-section-id]');
    var purchaseArea = section
      ? section.querySelector('[data-purchase-area]')
      : document.querySelector('[data-purchase-area]');
    if (!purchaseArea) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        bar.setAttribute('data-stuck', entry.isIntersecting ? 'false' : 'true');
      });
    }, {
      threshold: 0
    });

    observer.observe(purchaseArea);
    observers.push(observer);
  }

  function initStickyCtas() {
    // Previous page's elements (and their observers) are detached after a
    // soft navigation; drop them before binding the new page's elements.
    observers.forEach(function(observer) {
      observer.disconnect();
    });
    observers = [];

    document.querySelectorAll('sticky-add-to-cart').forEach(initStickyCta);
  }

  initStickyCtas();
  document.addEventListener('site:navigation:end', initStickyCtas);
})();
